import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WorkbenchConfiguratorItem } from '../../configurator/applications/workbench-configurator-item';
import { IBaseComponent } from '../../configurator/i-base-component';
import { IWorkbenchPreview } from '../preview/i-workbench-preview';
import { WorkbenchService } from 'src/app/services/configurators-2d/applications/workbench.service';
import { Configurators2DComponent } from '../../configurators-2d.component';
import { isPlanColorValid } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration-plan';
import { ConfigurationSplashback } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration-splashback';
import { Cutting } from 'src/app/models/configurators-2d/applications/workbench/cutting';
import { ConfigurationSideCut } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration-side-cut';
import { SideCut } from 'src/app/models/configurators-2d/applications/workbench/side-cut';
import { allSplashbackHaveHeight } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration';

@Component({
  selector: 'ng-workbench-splashbacks',
  templateUrl: './splashbacks.component.html',
})
export class WorkbenchSplashbacksComponent extends WorkbenchConfiguratorItem implements OnInit, IBaseComponent {
  preview: IWorkbenchPreview;
  cuttings: Cutting[];
  sideCuts: SideCut[];
  isVisible: boolean;
  typeProjet: string = 'PLAN_TRAVAIL';
  planId: string;
  // Side cut
  hasSideCut: boolean = false;
  disableRadioButtonCredence: boolean = true;
  disableRadioButtonWorkbench: boolean = false;


  @Output() isFinishesSplashback = new EventEmitter<boolean>();
  @Output() onWorkbenchSplashback = new EventEmitter<void>();
  @Output() disableNextButton = new EventEmitter<boolean>();

  constructor(
    public workbenchService: WorkbenchService,
    configurators2DComponent: Configurators2DComponent
  ) {
    super(workbenchService);
    this.preview = configurators2DComponent.preview as IWorkbenchPreview;
  }

  async ngOnInit(): Promise<void> {
    console.log("Chargement splash ", this.configuration);
    // Légende
    this.preview.updateLegend(true);
    // Déselection du plan en cours d'utilisation à l'étape précédente.
    this.preview.previewSelectPlanById(null);
    // Definition des actions à faire suivant l'étape du configurateur.
    this.preview.actionByConfiguratorStep();

    // Abonnement aux changements de crédences depuis la 3D
    if (this.preview.onSplashbackChange) {
      this.preview.onSplashbackChange.subscribe(() => {
        const hasSplashbacks = this.configuration.workbenchConfigurationPlans.some(p => p.configurationSplashbacks?.length > 0);
        if (hasSplashbacks) {
          if (this.typeProjet === 'PLAN_TRAVAIL') {
            this.typeProjet = 'CREDENCE_PLAN_TRAVAIL';
            this.onTypeProjetChange(new Event('change'));
          }
        } else if (this.typeProjet !== 'PLAN_TRAVAIL') {
          this.typeProjet = 'PLAN_TRAVAIL';
          this.onTypeProjetChange(new Event('change'));
        }
        this.updateSplashbackState();
      });
    }

    // Découpe de côté
    this.hasSideCut =
      this.configuration.workbenchConfigurationPlans.find(p => p.configurationSplashbacks.length > 0) &&
      this.configuration.workbenchConfigurationPlans.every(p =>
        p.configurationSplashbacks.every(s => s.configurationSideCuts && s.configurationSideCuts.length > 0)
      );

    // Affichage des controle de crédence.
    await this.preview.recreateSplashbacks();
    this.preview.showSplashbackControls(true);

    if (this.splashbackCanHaveSideCuts()) {
      this.sideCuts = await this.service.getSideCuts(this.configuration.workbenchConfigurationPlans[0].material.id);
      if (this.hasSideCut) {
        //le recreateSplashbacks supprime les sideCut. S'il y en avait, il faut les recréer
        this.updateSplashbackSideCuts();
      }
    }

    // Récupération des ouvertures.
    this.service.getCuttings(this.configuration.workbenchConfigurationPlans[0].material.id).then(cuttings => {
      this.cuttings = cuttings.filter(r => r.isSplashBackCutting);
      // Reload
      // Dessine les crédences
      if (this.configuration.workbenchConfigurationPlans.some(p => p.configurationSplashbacks.length > 0)) {
        // Si des ouvertures présentes on ajoute le cutting aux données.
        this.setCuttingToSplashback();
        // Reload
        const reload = new CustomEvent('reload', { detail: { value: this.getSplashbackHeight() } });
        this.changeSplashbackHeight(reload);
      }
    });

    //Vérification d'un retour en arrière dans le fil d'ariane.
    const currentPlanId = this.configuration.workbenchConfigurationPlans[0].id;
    const storedPlanId = localStorage.getItem('planId');
    if (currentPlanId === storedPlanId) {
      this.typeProjet = localStorage.getItem('typeProjet') || 'CREDENCE_PLAN_TRAVAIL';
    } else {
      //Vérifier la configuration car chargement d'un projet éventuel
      this.configuration.workbenchConfigurationPlans.forEach(plan => {
        if (Array.isArray(plan.configurationSplashbacks)) {
          plan.configurationSplashbacks.forEach(splashback => {
            if (splashback.isOnlySplashback === true) {
              this.typeProjet = 'CREDENCE_SEULE';
            } else if (this.hasSplashbacks()) {
              this.typeProjet = 'CREDENCE_PLAN_TRAVAIL';
            } else {
              this.typeProjet = 'PLAN_TRAVAIL';
            }
          });
        }
      });
    }

    // Safety check: if we have splashbacks, we cannot be in PLAN_TRAVAIL mode
    const actuallyHasSplashbacks = this.configuration.workbenchConfigurationPlans.some(
      plan => plan?.configurationSplashbacks?.length > 0
    );
    if (actuallyHasSplashbacks && this.typeProjet === 'PLAN_TRAVAIL') {
      this.typeProjet = 'CREDENCE_PLAN_TRAVAIL';
    }

    this.planId = currentPlanId;

    // Initial State Check - must be called AFTER typeProjet is determined from loaded config
    this.updateSplashbackState();

    // Auto-expand the "Ouvertures de crédences" section if splashbacks are present
    if (actuallyHasSplashbacks) {
      this.isVisible = true;
    }
  }

  setCuttingToSplashback() {
    for (let plan of this.configuration.workbenchConfigurationPlans) {
      for (let splashback of plan.configurationSplashbacks) {
        if (splashback.configurationCuttings) {
          for (let cutting of splashback.configurationCuttings) {
            cutting.cutting = this.cuttings.find(c => c.id == cutting.cuttingId);
          }
        }
      }
    }
  }

  splashbackCanHaveSideCuts() {
    return this.configuration.workbenchConfigurationPlans.every(
      p => p?.materialThickness?.canHaveSideCuts /*&& p?.color?.range?.name === SILESTONE_NAME*/
    );
  }

  updateSplashbackSideCuts() {
    for (let plan of this.configuration.workbenchConfigurationPlans) {
      for (let splashback of plan.configurationSplashbacks) {
        if (this.hasSideCut) {
          splashback.configurationSideCuts = [];
          // Pour chaque crédence on ajoute tout les côté en découpe.
          let sideCuts: Array<ConfigurationSideCut> = [
            // Deux fois la longueur
            new ConfigurationSideCut(
              null,
              null,
              this.sideCuts.find(s => !s.isOnlyOnJamb),
              splashback.length
            ),
            new ConfigurationSideCut(
              null,
              null,
              this.sideCuts.find(s => !s.isOnlyOnJamb),
              splashback.length
            ),
            // Deux fois la hauteur
            new ConfigurationSideCut(
              null,
              null,
              this.sideCuts.find(s => !s.isOnlyOnJamb),
              splashback.height
            ),
            new ConfigurationSideCut(
              null,
              null,
              this.sideCuts.find(s => !s.isOnlyOnJamb),
              splashback.height
            ),
          ];
          splashback.configurationSideCuts = sideCuts;
        } else {
          splashback.configurationSideCuts = [];
        }
      }
    }
  }

  /**
   * Récupère la valeur de la hauteur de crédence.
   *
   */
  getSplashbackHeight(): number {
    if (this.hasSplashbacks()) {
      let splashback: ConfigurationSplashback;
      // On prend le premier plan qui possède des crédences et on prend la première crédence qui à une hauteur.
      splashback = this.configuration.workbenchConfigurationPlans
        .find(plan => plan.configurationSplashbacks.length > 0)
        ?.configurationSplashbacks.find(splashback => splashback != null && splashback.height > 0);
      return splashback?.height > 0 ? splashback?.height : 0;
    } else {
      return 0;
    }
  }

  /**
   * Met à jour la hauteur pour toute les crédences.
   * @param event
   */
  changeSplashbackHeight(event: Event): void {
    let height = 0;
    if (event.type == 'reload') {
      height = parseInt((event as CustomEvent).detail.value);
    } else {
      height = parseInt((event.target as HTMLInputElement).value);
    }

    this.configuration.workbenchConfigurationPlans.forEach(plan => {
      plan.configurationSplashbacks.forEach(splashback => {
        if (splashback != null) {
          splashback.height = height;
        }
      });
    });

    this.preview.createOrUpdateOptionalPreview();
  }

  /**
   * Regarde si la hauteur est invalide
   * Valide : ne possède pas crédence ou des crédences avec une hauteur valide.
   * Invalide : possède au moins une crédence avec une hauteur invalide.
   */
  isHeightValid(): boolean {
    return allSplashbackHaveHeight(this.configuration);
  }

  /**
   * Regarde si la configuration possède des crédences
   * True si crédence / False sinon
   */
  /**
   * Regarde si la configuration possède des crédences
   * True si crédence / False sinon
   */
  hasSplashbacks(): boolean {
    return this.configuration.workbenchConfigurationPlans.some(
      plan => plan?.configurationSplashbacks?.length > 0
    );
  }

  updateSplashbackState() {
    const hasSplashbacks = this.hasSplashbacks();
    const type = this.typeProjet;

    // Met à jour la variable qui contrôle le blocage des options radio
    // Avoid NG0100 by checking if value actually changed?
    // Or just let it be, called from safe places.
    this.disableRadioButtonCredence = !hasSplashbacks;
    this.disableRadioButtonWorkbench = hasSplashbacks;

    if (hasSplashbacks) {
      if (type === 'PLAN_TRAVAIL') {
        this.disableNextButton.emit(true);
      } else if (type === 'CREDENCE_SEULE' || type === 'CREDENCE_PLAN_TRAVAIL') {
        this.disableNextButton.emit(false);
      }
    } else {
      if (type === 'PLAN_TRAVAIL') {
        this.disableNextButton.emit(false);
      } else if (type === 'CREDENCE_SEULE' || type === 'CREDENCE_PLAN_TRAVAIL') {
        this.disableNextButton.emit(true);
      }
    }
  }

  toggleCollapse() {
    this.isVisible = !this.isVisible;
  }

  isNextButtonActive(): boolean {
    return !this.hasSplashbacks() || (this.hasSplashbacks() && this.isHeightValid());
  }

  checkPageChangeCapability(): boolean {
    return this.configuration.workbenchConfigurationPlans.every(plan => isPlanColorValid(plan));
  }

  onTypeProjetChange(event: Event) {
    localStorage.setItem('planId', this.planId);
    localStorage.setItem('typeProjet', this.typeProjet);
    const isOnlySplashback = this.typeProjet === 'CREDENCE_SEULE';
    this.configuration.workbenchConfigurationPlans.forEach(plan => {
      if (Array.isArray(plan.configurationSplashbacks)) {
        plan.configurationSplashbacks.forEach(splashback => {
          splashback.isOnlySplashback = isOnlySplashback;
        });
      }
    });
    this.isFinishesSplashback.emit(!isOnlySplashback);
    this.updateSplashbackState();
  }

}
